(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-billing-config', {
                parent: 'entity',
                url: '/facility-billing-config',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityBillingConfigs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-billing-config/list/facility-billing-config.html',
                        controller: 'FacilityBillingConfigController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
